<template>
    <qtm-btn class="text-interactive" :class="{ pulse: newNews }" tertiary @click="$emit('update:model-value', true)">
      <v-badge
        color="primary"
        dot
        height="8"
        location="top start"
        :model-value="newNews"
        offset-x="0"
        offset-y="2"
        width="8"
      >
        <div class="d-flex align-center">
            <tips-icon class="mr-2" />
            News
        </div>
      </v-badge>
    </qtm-btn>
</template>

<script setup lang="ts">
import TipsIcon from '~/components/news/tips-icon.vue'
import { newNews } from './news-store'

defineEmits(['update:model-value'])
</script>

<style lang="scss">
.pulse .v-badge__badge {
  animation: pulse-animation 0.5s;
  animation-iteration-count: 4;
}

@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
  }
}
</style>
